
import BaseStore from '../base-store'
let options = {}
export default new BaseStore('categories', options)



// WEBPACK FOOTER //
// ./src/store/modules/categories.store.js